import { connect } from 'react-redux'
import fetchActivities from '../sagas/fetchActivities'
import { sagaActions as rootSagaActions } from 'store/sagas'
import activitiesSelector from './activitiesSelector'
import Activities from './Activities'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  activitiesSelector,
  {
    fetchActivities,
    requestChangeUserSettings: rootSagaActions.requestChangeUserSettings,
  }
)(Activities))
